
<div class="OrdersView">
	<div class="columns is-mobile">
		<aside class="column is-fullheight-desktop is-two-fifths-desktop OrdersView__Aside">
			<div class="OrdersView__Tables">
				<nav class="tabs is-boxed">
					<ul>
						<li :class="{ 'is-active': currentTab === 'pending' }" @click="selectTab('pending')">
							<a>{{ capitalizeFirstLetter(config.orderStatusNames.pending) }}</a>
						</li>
						<li :class="{ 'is-active': currentTab === 'new' }" @click="selectTab('new')">
							<a>
								{{ capitalizeFirstLetter(config.orderStatusNames.new) }}
								<!-- <b-tag rounded type="is-primary">{{ totalNewOrders }}</b-tag> -->
							</a>
						</li>
						<li :class="{ 'is-active': currentTab === 'planned' }" @click="selectTab('planned')">
							<a>{{ capitalizeFirstLetter(config.orderStatusNames.planned) }}</a>
						</li>
						<li
							v-if="config.isInProductionStatusEnabled"
							:class="{ 'is-active': currentTab === 'inProduction' }"
							@click="selectTab('inProduction')"
						>
							<a>{{ capitalizeFirstLetter(config.orderStatusNames.inProduction) }}</a>
						</li>
						<li :class="{ 'is-active': currentTab === 'sent' }" @click="selectTab('sent')">
							<a>{{ capitalizeFirstLetter(config.orderStatusNames.sent) }}</a>
						</li>
						<li
							:class="{ 'is-active': currentTab === 'archived' }"
							@click="selectTab('archived')"
						>
							<a>{{ capitalizeFirstLetter(config.orderStatusNames.archived) }}</a>
						</li>
						<li
							v-if="config.canMoveToComplaints"
							:class="{ 'is-active': currentTab === 'complaint' }"
							@click="selectTab('complaint')"
						>
							<a>{{ capitalizeFirstLetter(config.orderStatusNames.complaint) }}</a>
						</li>
						<li
							v-if="config.canMoveToTrash"
							:class="{ 'is-active': currentTab === 'trashed' }"
							@click="selectTab('trashed')"
						>
							<a>{{ capitalizeFirstLetter(config.orderStatusNames.trashed) }}</a>
						</li>
						<li :class="{ 'is-active': currentTab === 'all' }" @click="selectTab('all')">
							<a>{{ capitalizeFirstLetter(config.orderStatusNames.all) }}</a>
						</li>
					</ul>
				</nav>

				<div class="level">
					<b-field
						horizontal
						label="Kraj"
						v-if="
							config.isFilterByCountryEnabled &&
							(currentTab === 'pending' || currentTab === 'new')
						"
						class="view-mode-toggle level-left"
					>
						<b-field class="field-body" grouped>
							<b-select
								placeholder="Wybierz kraj"
								:value="filterCountry"
								@input="selectFilterCountry"
							>
								<option :value="null">dowolny</option>
								<option value="PL">Polska</option>
								<option value="CZ">Czechy</option>
								<option value="SK">Słowacja</option>
								<option value="RO">Rumunia</option>
								<option value="HU">Węgry</option>
								<option value="DE">Niemcy</option>
								<option value="AT">Austria</option>
								<option value="HR">Chorwacja</option>
								<option value="SI">Słowenia</option>
							</b-select>
						</b-field>
					</b-field>

					<b-field
						horizontal
						label="Widok"
						v-if="currentTab !== 'pending' && currentTab !== 'new'"
						class="view-mode-toggle level-left"
					>
						<b-field>
							<b-radio-button :value="viewMode" native-value="orders" @input="selectViewMode">
								<span>Zamówienia</span>
							</b-radio-button>
							<b-radio-button :value="viewMode" native-value="routes" @input="selectViewMode">
								<span>Trasy</span>
							</b-radio-button>
						</b-field>
					</b-field>

					<b-field grouped class="level-right search-field">
						<div class="control is-clearfix">
							<input
								placeholder="Imię nazwisko, tel, NR zam."
								type="search"
								class="input"
								v-model="searchText"
								@keyup.enter="search(searchText)"
								@input="checkIsSearchReseted"
							/>
						</div>
						<p class="control">
							<button class="button is-primary" @click="search(searchText)">Szukaj</button>
						</p>
					</b-field>
				</div>

				<orders-table
					v-show="viewMode === 'orders' || currentTab === 'new'"
					@update:checkedRows="ordersTableRowSelect"
					@order-click="$emit('order-click', $event)"
					@route-click="$emit('route-click', $event)"
				/>

				<routes-table
					v-show="viewMode === 'routes' && currentTab !== 'new'"
					@update:checkedRows="routesTableRowSelect"
					@route-click="$emit('route-click', $event)"
				/>
			</div>
			<Footer />
		</aside>
		<div class="column OrdersView__Map">
			<Map @order-click="$emit('map-order-click', $event)" />
		</div>
	</div>
</div>
